var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.922 31.4354C12.0551 31.4354 10.3067 31.081 8.67683 30.372C7.04592 29.6621 5.62709 28.7033 4.42034 27.4955C3.21259 26.2888 2.25376 24.87 1.54385 23.239C0.834927 21.6091 0.480469 19.8607 0.480469 17.9939H3.46748C3.46748 20.9062 4.48207 23.3765 6.51125 25.4046C8.53943 27.4338 11.0097 28.4484 13.922 28.4484C16.8344 28.4484 19.3046 27.4338 21.3328 25.4046C23.362 23.3765 24.3766 20.9062 24.3766 17.9939C24.3766 15.0815 23.362 12.6108 21.3328 10.5816C19.3046 8.5534 16.8344 7.53931 13.922 7.53931H13.698L16.0129 9.85425L13.922 12.0198L7.948 6.0458L13.922 0.0717773L16.0129 2.23736L13.698 4.5523H13.922C15.7889 4.5523 17.5378 4.90725 19.1687 5.61717C20.7986 6.32608 22.2175 7.28392 23.4252 8.49067C24.632 9.69842 25.5903 11.1173 26.3002 12.7472C27.0091 14.3781 27.3636 16.127 27.3636 17.9939C27.3636 19.8607 27.0091 21.6091 26.3002 23.239C25.5903 24.87 24.632 26.2888 23.4252 27.4955C22.2175 28.7033 20.7986 29.6621 19.1687 30.372C17.5378 31.081 15.7889 31.4354 13.922 31.4354Z",
    fill: "#D94854"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplay);
export default __webpack_public_path__ + "static/media/replay.beebcd0bd9c58c07c1e31794ae859fb5.svg";
export { ForwardRef as ReactComponent };